module.exports = __webpack_public_path__ + "static/img/Logo-menu.55b64c4f.png";